import router from "./router";
import { getToken } from "common/auth"; // get token from cookie
import Cookies from 'js-cookie'
import homeStore from "home/homeStore"

router.beforeEach(async (to, from, next) => {
  const hasToken = getToken();
  if (hasToken) {
    if(to.query.fillingRoles){
      if(to.query.fillingRoles.includes('4')){
        next()
      }else{
        let userType = Cookies.get('userType')
        if(to.query.fillingRoles.includes(userType)){
          next()
        }else{
          next('/home')
        }
      }
    }else{
      next()
    }
  } else {
    let userType = Cookies.get('loginUserType')
    if(!to.meta.isLogin){
      if(homeStore.state.isProduction && to.path === '/home'){
        if(userType == 1){
          next('/login/studentLogin')
        }else if(userType == 2){
          next('/login/teacherLogin')
        }else if(userType == 3){
          next('/login/companyLogin')
        }
      }else{
        next()
      }
    }else{
      if(to.query.fillingRoles){
        localStorage.setItem('fillingRoles', to.query.fillingRoles)
        if(to.query.fillingRoles.includes('4')){
          next()
        }else{
          localStorage.setItem('isJumpQuestionnaireId', to.query.id)
          if(to.query.fillingRoles === '1'){
            next('/login/studentLogin')
          }else if(to.query.fillingRoles === '2'){
            next('/login/teacherLogin')
          }else if(to.query.fillingRoles === '3'){
            next('/login/companyLogin')
          }else{
            next('/login/checkRolesLogin')
          }
        }
      }else{
        if(homeStore.state.isProduction){
          if(userType == 1){
            next('/login/studentLogin')
          }else if(userType == 2){
            next('/login/teacherLogin')
          }else if(userType == 3){
            next('/login/companyLogin')
          }
        }else{
          next('/home')
        }
      }
    }
  }
});
